export const elements = {
  menu: document.querySelector('.menu'),
  sidebar: document.querySelector('.sidebar'),
  addProjects: document.querySelector('.sb-p-title'),
  addProjectsIcon: document.querySelector('.sb-p-title i'),
  newProjectForm: document.querySelector('.new-project'),
  newPSubmit: document.querySelector('.new-p-submit'),
  projectUL: document.querySelector('.sb-p-items'),
  select: document.getElementById('select'),
  main: document.querySelector('main'),
  todoFormDiv: document.querySelector('.todo-form'),
  todoForm: document.getElementById('todoForm'),
  todoListUL: document.querySelector('.td-list'),
  all: document.querySelector('.sb-all'),
  today: document.querySelector('.sb-today'),
  submit: document.querySelector('.submit'),
};

export const prevProject = [];